import { oneOfType, func, string, element } from 'prop-types';
import WithIcon from './layouts/WithIcon';
import PreviousSvg from 'imagesUwKluis/svg/back.svg';
import { Box } from './layouts';
import i18n from "../../i18n";

const BackButton = ({ onClick, children=i18n.t('Terug') }) => (
  <WithIcon css={{ cursor: 'pointer' }} color='primaryFont' onClick={onClick}>
    <PreviousSvg
      width="1.5rem"
      height="1.5rem"
    />
    <Box fontWeight='bold' css={{ textDecoration: 'underline' }}>
      {children}
    </Box>
  </WithIcon>
);

BackButton.propTypes = {
  onClick: func.isRequired,
  children: oneOfType([string, element])
};

export default BackButton;
